export const legalH2 = 'text-xl font-bold sm:text-2xl';
export const legalH3 = 'mt-4 text-base font-bold';
export const legalP = 'mt-3 text-[15.5px] leading-relaxed text-muted-foreground';

export function LegalSection({ children }: { children: React.ReactNode }) {
  return (
    <section className="mt-10 border-t pt-8 first:mt-9 first:border-t-0 first:pt-0">
      {children}
    </section>
  );
}

/**
 * Tailwind Preflight sets `ul, ol { list-style: none }`, which strips the
 * implicit ARIA list/listitem roles in Safari/VoiceOver (Chrome/Firefox keep
 * them). Callers must render the wrapping `<ul>` with `role="list"` — this
 * component supplies the matching `role="listitem"` on each `<li>`.
 */
export function LegalListItem({ children }: { children: React.ReactNode }) {
  return (
    <li role="listitem" className="flex gap-2 text-[15.5px] leading-relaxed text-muted-foreground">
      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-muted-foreground" />
      <span>{children}</span>
    </li>
  );
}
